module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Rainbow Connection Box Set")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("By Lynn Townsend")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "id": "a3"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "href": "#/006#a87"
    }
  }, [_vm._v("On a Roll")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('a', {
    attrs: {
      "href": "#/006#a88"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('a', {
    attrs: {
      "href": "#/007#a89"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('a', {
    attrs: {
      "href": "#/008#a90"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('a', {
    attrs: {
      "href": "#/009#a91"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('a', {
    attrs: {
      "href": "#/010#a92"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('a', {
    attrs: {
      "href": "#/011#a93"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('a', {
    attrs: {
      "href": "#/012#a94"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('a', {
    attrs: {
      "href": "#/013#a95"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/014#a96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/015#a97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/016#a98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/017#a99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/018#a100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/019#a101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/020#a102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/021#a103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/022#a104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/023#a106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/024#a107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/025#a108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/026#a109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/027#a110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/028#a111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/029#a112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/030#a113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/031#a114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/032#a115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Got the Blues")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/032#a116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/033#a117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/034#a118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/035#a119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/036#a120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/037#a121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/038#a122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/039#a123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/040#a124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/041#a125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/042#a126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/043#a127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/044#a128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/045#a129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/046#a130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/047#a131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/048#a132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/049#a133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/050#a134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/051#a135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/052#a136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/053#a137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/054#a138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/055#a139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/056#a140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/057#a141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/058#a142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/059#a143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Classic Blunder")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/059#a144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/060#a145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/061#a146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/062#a148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/063#a149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/064#a150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/065#a152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/066#a153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/067#a154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/068#a155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/069#a156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/070#a157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/071#a158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/072#a159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/073#a160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/074#a161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/075#a162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/076#a163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/077#a164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/078#a165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/079#a166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/080#a167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/081#a168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    attrs: {
      "href": "#/082#a169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")]), _c('a', {
    attrs: {
      "href": "#/#a86"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h10"
  }, [_c('a', {
    attrs: {
      "id": "ncx106"
    }
  }), _c('a', {
    attrs: {
      "id": "a86"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af0d7b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005.vue
// module id = 66
// module chunks = 0